/* unplugin-vue-components disabled */import { render } from "./xareaSelect.vue?vue&type=template&id=73c1359d"
import script from "./xareaSelect.vue?vue&type=script&lang=js"
export * from "./xareaSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__